module.exports = __webpack_public_path__ + "img/0Q3A2940_L_Foamcore.60bb3811.jpg";